import classNames from 'class-names';
import PropTypes from 'prop-types';
import React from 'react';

import { Icon, IconWiFiSignal } from '../../Atoms/Icon';
import Switch from '../../Atoms/Switch/Switch';
import { WanConnections } from '../../lib/utils/helpers';
import { signalIcon } from '../TerminalHome/Wan/Cell';
import Content from '../TerminalHome/Wan/Content';
import styles from '../TerminalHome/Wan/wan.module.css';

const mapping = {
  cell: {
    text: 'cell',
    noSignalIcon: 'signal-thick-0',
    inActiveIcon: 'signal-thick',
    iconDisableClass: classNames('mt-3', styles.iconXl),
    line1: 'SIM CARD',
    className: 'pt-2 pb-0',
    line1ClassName: 'text-gray-600 mt-2',
    line2ClassName: 'text-green text-uppercase',
    networkClassName: 'font-weight-bold mt-n1',
  },
  wifi: {
    text: 'wi-fi',
    switch: true,
    noSignalIcon: 'wifi-thick-0',
    inActiveIcon: 'wifi-thick',
    iconDisableClass: classNames('display-1', styles.iconXXl),
    line1: 'Signal',
    className: 'pb-2',
    line1ClassName: 'text-gray-600 mt-n2',
    line2ClassName: 'text-green text-uppercase',
    networkClassName: '',
  },
};

const ConnectionContent = ({
  active,
  mode,
  signalStrengthNormalized,
  type,
  line1,
  line2,
  line1ClassName = '',
  line2ClassName = '',
}) => {
  if (!active) {
    return (
      <div>
        <Icon
          role="status"
          className={classNames('text-gray-500', mode.iconDisableClass)}
          name={mode.inActiveIcon}
        />
        <div className="text-gray font-weight-bold pt-2">-</div>
      </div>
    );
  }

  return (
    <Content
      icon={
        type === 'cell' ? (
          <Icon
            role="status"
            name={signalIcon(signalStrengthNormalized)}
            className={classNames('text-primary', styles.iconXl)}
          />
        ) : (
          <IconWiFiSignal
            signalStrength={signalStrengthNormalized}
            className={classNames(
              active ? 'text-primary' : 'text-gray-200',
              styles.iconXXl,
            )}
          />
        )
      }
      line1={line1}
      line2={line2}
      line1ClassName={line1ClassName}
      line2ClassName={line2ClassName}
      className={mode.className}
    />
  );
};

ConnectionContent.propTypes = {
  active: PropTypes.bool,
  line1: PropTypes.string,
  mode: PropTypes.shape({
    className: PropTypes.string,
    iconDisableClass: PropTypes.string,
    inActiveIcon: PropTypes.string,
  }),
  line2: PropTypes.string,
  line1ClassName: PropTypes.string,
  line2ClassName: PropTypes.string,
  type: PropTypes.oneOf(['cell', 'wifi']),
  signalStrengthNormalized: PropTypes.number,
};

const WanConnectionBox = ({
  active,
  type,
  networkName,
  onStatusChange,
  loading,
  readOnly,
  signalStrength = 0,
  operatorName,
  dataCapability,
  connectionStatus = '',
}) => {
  const mode = mapping[type];
  let { line1 } = mode;
  let line2 = '';
  const { line1ClassName } = mode;
  let { line2ClassName } = mode;
  if (type === 'cell') {
    line1 = operatorName ? `${operatorName} ${dataCapability}` : '-';
    line2 = networkName || '-';
    line2ClassName = mode.networkClassName;
  }
  if (type === 'wifi') {
    line1 = '';
    line2 = '';
    line2ClassName = '';
  }

  return (
    <div className="border-0">
      <div className="d-flex ">
        <div className="border-left border-top col-7 d-flex justify-content-between px-0 py-1 bg-white">
          <span className="d-flex pl-2 align-items-center">
            <strong className="pl-2 text-uppercase">{mode.text}</strong>
          </span>
          <div className="d-flex align-items-center pr-2">
            {!readOnly && (
              <Switch
                name="switch"
                disabled={loading}
                checked={active}
                onChange={onStatusChange}
              />
            )}
          </div>
        </div>

        <div className="border-left border-bottom col-5">&nbsp;</div>
      </div>
      <div>
        <div
          className={classNames(
            'border border-top-0 pb-3 text-center bg-white',
          )}
        >
          <div
            className="align-items-center d-flex justify-content-end pr-2 text-right"
            style={{ height: '30px' }}
          >
            {active && connectionStatus === 'no_internet' && (
              <Icon name="danger-filled" className="text-orange h4 mb-0" />
            )}
          </div>
          <ConnectionContent
            active={active}
            mode={mode}
            type={type}
            line1={line1}
            line2={line2}
            signalStrengthNormalized={signalStrength}
            line1ClassName={line1ClassName}
            line2ClassName={line2ClassName}
          />
          {type === 'wifi' && (
            <div>{networkName === '' && active ? '-' : networkName}</div>
          )}
        </div>
      </div>
    </div>
  );
};

WanConnectionBox.propTypes = {
  active: PropTypes.bool.isRequired,
  type: PropTypes.oneOf(['cell', 'wifi']).isRequired,
  networkName: PropTypes.string,
  onStatusChange: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  readOnly: PropTypes.bool,
  signalStrength: PropTypes.number,
  operatorName: PropTypes.string,
  dataCapability: PropTypes.string,
  connectionStatus: PropTypes.oneOf(['', ...WanConnections]),
};

export default WanConnectionBox;
